export default function makeFieldRequired(path, required) {
  function action(context) {
    let state = context.state
    state.merge(path, { isRequired: required })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/makeFieldRequired.js